export { default } from './Slide';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Slide/index.js
// module id = 545
// module chunks = 121